module.exports = __webpack_public_path__ + "img/photo_camera_black.937ecefe.svg";